import { render, staticRenderFns } from "./KpisResumoAtendentes.vue?vue&type=template&id=b25cdfa4&scoped=true"
import script from "./KpisResumoAtendentes.vue?vue&type=script&lang=js"
export * from "./KpisResumoAtendentes.vue?vue&type=script&lang=js"
import style0 from "./KpisResumoAtendentes.vue?vue&type=style&index=0&id=b25cdfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25cdfa4",
  null
  
)

export default component.exports